/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IDobbiesBuyboxProductDetailsViewProps } from './dobbies-buybox-product-details';

export default (props: IDobbiesBuyboxProductDetailsViewProps) => {
    const {
        data: {
            product: { result: productData },
            productAttributes: { result: attributes }
        },
        resources
    } = props;

    const { tag: Tag = 'h2', text = '' } = props.config.heading || {};

    // const isVendorShipProduct = attributes?.find(
    //     attr => attr.Name === 'IsVendershipProduct' && attr.TextValue && attr.TextValue.toLowerCase() === 'yes'
    // );
    // const vendorName = attributes?.find(attr => attr.Name === 'VendorName');
    const productDetails = attributes?.find(attr => attr.Name === 'Product details');
    return (
        <div className='row ms-buybox ms-buybox__product-details flex-column'>
            <div className='product-details-header'>
                <Tag id='product-details' style={{ scrollMarginTop: '50px' }}>
                    {text.toLocaleLowerCase()}
                </Tag>
                <span>
                    {resources.productCodeText} {productData?.ItemId}
                </span>

                {productDetails?.TextValue && (
                    <div className='product-description' dangerouslySetInnerHTML={{ __html: productDetails.TextValue }} />
                )}
                {/* TODO: Need to remove this after validation */}
                {/* {isVendorShipProduct && (
                    <div className='vendorInfo'>
                        {resources.vendorShippingText} {vendorName?.TextValue}
                    </div>
                )} */}
            </div>
            <div className='product-details'>{props.DetailsAccordion}</div>
        </div>
    );
};
